import AwesomeSlider from "react-awesome-slider"
import withAutoplay from "react-awesome-slider/dist/autoplay"
import "react-awesome-slider/dist/styles.css"
import "./auto-play-slider.scss"
const AutoplaySlider = withAutoplay(AwesomeSlider)

export default AutoplaySlider
